const DEVICE_ID_STORAGE_KEY = "appUpdateDeviceId";

/**
 * FLIP-479. A random per-install id sent with the announcement calls so the server tracks
 * "seen" per device: the browser and the mobile WebView shell have separate localStorage, so
 * they get separate ids, and updating on one no longer consumes the announcement on the other.
 *
 * Returns null when storage is unavailable (private mode, blocked) - the server then falls
 * back to the legacy per-user row, which is the pre-FLIP-479 behaviour, rather than minting
 * a fresh id on every call and re-showing the modal every session.
 */
export function getAppUpdateDeviceId(): string | null {
  try {
    let id = localStorage.getItem(DEVICE_ID_STORAGE_KEY);
    if (!id) {
      id = generateId();
      localStorage.setItem(DEVICE_ID_STORAGE_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

function generateId(): string {
  const c = (globalThis as any).crypto;
  if (c && typeof c.randomUUID === "function") {
    return c.randomUUID();
  }
  return "d-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 12);
}
